// eslint-disable-next-line no-use-before-define
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Paper } from "@material-ui/core";
import {
  fetchPharmacyApproveData,
  updatePharmacyApproveData,
  getInServiceProfitCenters,
} from "../../redux";
import PharmacyPeriodRow from "./pharmacyPeriodRow";
import { generateCompensationPeriods } from "../../utils/compensation/compensation";
import {
  Header,
  ConsentPopup,
  CompensationSearchControls,
  CompensationTitle,
} from "../common";

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    padding: "1rem",
  },
  actionContainer: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  error: {
    color: "red",
    ...theme.typography.body1,
  },
}));

function Pharmacy() {
  const classes = useStyles();
  useTranslation();
  const dispatch = useDispatch();
  const [currentYear, setCurrentYear] = useState(moment().year().toString());
  const { userData } = useSelector(state => state.user);
  // TODO: handle consent fetching and sending errors
  const { approvals } = useSelector(state => state.pharmacy);
  const {
    compensationsMap,
    filteredCompensationsMap,
    filteredCompensationCount,
    fetchError,
    fetchingMap,
    searching,
    searchError,
  } = useSelector(state => state.compensation);
  const [showConsent, setShowConsent] = useState(false);
  const [periods, setPeriods] = useState([]);
  const inServiceProfitCenters = useSelector(
    state => state.profitCenters.inServiceProfitCenters
  );

  useEffect(() => {
    // set periods
    setPeriods(generateCompensationPeriods(currentYear).reverse());
  }, [currentYear, setPeriods]);

  useEffect(() => {
    const { organizationIds } = userData;
    if (organizationIds.length) {
      dispatch(fetchPharmacyApproveData(organizationIds));
    }
  }, [userData, dispatch]);

  useEffect(() => {
    if (approvals != null) {
      // check against organization ids
      const { organizationIds } = userData;
      for (let i = 0; i < organizationIds.length; i += 1) {
        const approval = approvals.find(
          item => item.customerNumber === organizationIds[i]
        );
        if (approval.approved === false) {
          setShowConsent(true);
          break;
        }
      }
    }
  }, [approvals, userData]);

  useEffect(() => {
    dispatch(getInServiceProfitCenters());
  }, [dispatch]);

  const onAccept = updatedApprovals => {
    updatedApprovals.forEach(updatedApproval => {
      const params = {
        ...updatedApproval,
        approverName: userData.name,
        approveTime: moment().toISOString(),
      };
      dispatch(updatePharmacyApproveData(params));
    });

    setShowConsent(false);
  };

  return (
    <Paper className={classes.root}>
      <Header showButton={false} />
      <ConsentPopup
        show={showConsent}
        top={100}
        right={110}
        onAccept={updatedApprovals => onAccept(updatedApprovals)}
        approvals={approvals || []}
      />
      <CompensationTitle />
      <CompensationSearchControls
        currentYear={currentYear}
        setCurrentYear={setCurrentYear}
        periods={periods}
        filteredCompensationsMap={filteredCompensationsMap}
        filteredCompensationCount={filteredCompensationCount}
        searching={searching}
        searchError={searchError}
        organizationIds={userData.organizationIds}
      />
      {periods.map((period, index) => {
        // get compensations based on mode
        let compensations = null;
        if (filteredCompensationsMap != null) {
          compensations = filteredCompensationsMap.get(period.key) || [];
        } else {
          compensations = compensationsMap.get(period.key);
        }

        return (
          <PharmacyPeriodRow
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            preload={index < 6}
            period={period}
            compensations={compensations}
            fetchError={fetchError}
            fetching={fetchingMap.get(period.key) != null}
            inServiceProfitCenters={inServiceProfitCenters}
            showInServiceProfitCenters
          />
        );
      })}
    </Paper>
  );
}

export default Pharmacy;
